import React from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  Card as DSCard,
  Typography,
  useWindowSize,
} from 'vindi-ds-components';

const Description = ({
  isMobile, description, currency, color,
}) => (
  <Box display='flex' alignItems='flex-end'>
    {currency ? (
      <Box pb={{ xs: 0, md: 1 / 4 }} mr={1}>
        <Typography
          variant={isMobile ? 'subtitle1' : 'body1'}
          style={{ color }}
        >
          R$
        </Typography>
      </Box>
    ) : null}

    <Typography
      variant={isMobile ? 'subtitle1' : 'h5'}
      style={{ color }}
    >
      {description}
    </Typography>
  </Box>
);

const SubDescription = ({ isMobile, subDescription }) => (
  subDescription && (
    <Box display='flex' alignItems='center' my={1}>
      <Typography variant={isMobile ? 'caption' : 'body2'}>
        {subDescription}
      </Typography>
    </Box>
  )
);

const Card = ({
  colorPin, color, title, description, currency, subDescription = false,
}) => {
  const { isMobile } = useWindowSize();

  return (
    <DSCard data-testid='ds-card' width='100%'>

      <Box p={{ xs: 2, md: 3 }}>
        <Box display='flex' alignItems='center' mb={1}>
          <Box
            size={{ xs: '6px', md: '8px' }}
            borderRadius='50%'
            mr={1}
            bgcolor={colorPin || color}
            data-testid='card-pin'
          />
          <Typography variant={isMobile ? 'caption' : 'body1'}>
            {title}
          </Typography>
        </Box>

        <Description
          isMobile={isMobile}
          description={description}
          currency={currency}
          color={color}
        />

        <SubDescription
          subDescription={subDescription}
          isMobile={isMobile}
        />
      </Box>
    </DSCard>
  );
};

Card.defaultProps = {
  currency: false,
};

Card.propTypes = {
  color: PropTypes.string.isRequired,
  title: PropTypes.node.isRequired,
  description: PropTypes.node.isRequired,
  currency: PropTypes.bool,
};

export default Card;
